const $ = jQuery

/**
 * Function to zoom an image on click
 * @param {Event} event - The click event
 */
export const zoomImage = (event) => {
    const $img = $(event.target)
    const $imgWrapper = $img.closest('.zoom')

    $imgWrapper.toggleClass('zooming')

    if ($imgWrapper.hasClass('zooming')) {
        let scale = $imgWrapper.data('scale') || 1.75

        $img.css({
            transform: `scale(${scale})`,
            transformOrigin: `${event.offsetX}px ${event.offsetY}px`,
        })

        $imgWrapper
            .on('mouseover', function () {
                $img.css({
                    transform: `scale(${scale})`,
                })
            })
            .on('mouseout', function () {
                $img.css({
                    transform: 'scale(1)',
                })
            })
            .on('mousemove', function (e) {
                $img.css({
                    transformOrigin: `${e.offsetX}px ${e.offsetY}px`,
                })
            })
    } else {
        $img.css({
            transform: 'scale(1)',
        })
        $imgWrapper.off('mouseover mouseout mousemove')
    }
}
